import { DataLayerFunctions, DataLayerUser } from '@/components/DataLayer/DataLayerTypes';
import { FullUser } from '@/graphql/__generated/resolvers-types';

import { buildAdobeUserTrackingFields } from './buildAdobeUserTrackingFields';

type UserWithTrackingFields = FullUser & {
    isLoggedIn?: boolean;
    providerUserId?: string | null;
    paramountStreamingId?: string | null;
};

export const getUserInfo: DataLayerFunctions['getUserInfo'] = (user: FullUser | undefined) => {
    if (!user) {
        return {
            activeProfile: undefined,
            accountProfiles: undefined,
            bundleStatusTracking: undefined,
            cbsPackageInfo: undefined,
            multiPackageTracking: undefined,
            packageStatusTracking: undefined,
            sha256EmailHash: undefined,
            userStatus: undefined,
            isAuthenticated: false,
            providerUserId: undefined,
            paramountStreamingId: undefined,
            personalizationId: undefined,
        } as DataLayerUser;
    }

    const typedUser = user as UserWithTrackingFields;
    const { userStatus: userStatusTracking, ...adobeUserTrackingFields } =
        buildAdobeUserTrackingFields(user);

    return {
        activeProfile: user?.activeProfile,
        accountProfiles: user?.accountProfiles,
        cbsPackageInfo: user?.cbsPackageInfo?.[0],
        bundleStatusTracking: user?.bundleStatusTracking || '',
        multiPackageTracking: user?.entitlement?.multiPackageTracking,
        packageStatusTracking: user?.packageStatusTracking,
        sha256EmailHash: user?.sha256EmailHash,
        userStatus: user?.userStatus,
        isAuthenticated: typedUser?.isLoggedIn,
        providerUserId: typedUser?.providerUserId || '',
        paramountStreamingId: typedUser?.paramountStreamingId || '',
        personalizationId: user?.accountProfiles?.[0]?.personalizationId || '',
        ...adobeUserTrackingFields,
        userStatusTracking,
    } as DataLayerUser;
};
